import script from "./GlobalGroupsWorkspaceSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalGroupsWorkspaceSelect.vue?vue&type=script&setup=true&lang=js"

import "./GlobalGroupsWorkspaceSelect.vue?vue&type=style&index=0&id=ec4662d0&lang=scss&scoped=true"
import "./GlobalGroupsWorkspaceSelect.vue?vue&type=style&index=1&id=ec4662d0&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec4662d0"]])

export default __exports__